import Header from '../../shared/header/Header.vue'
import Footer from '../../shared/footer/Footer.vue'

export default {
  name: 'Job',
  components: {
    Header,
    Footer
  },
  props: {
    jobKey: String
  },
  created () {
    this.$store.dispatch('getJobs')
  },
  computed: {
    job () {
      return this.$store.getters.getJob(this.jobKey)
    }
  }
}
